import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
    output,
    input,
    computed,
} from '@angular/core';
import { IOnboardingCompletionStep } from '../../fi-onboarding-completion';
import { getIconClassByObjectType } from '@fi-shared/utils/get-icon-class-by-object-type';

@Component({
    selector: 'fi-completion-step',
    templateUrl: './completion-step.component.html',
    styleUrl: './completion-step.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-completion-step' },
    standalone: false,
})
export class FiCompletionStepComponent {
    public step = input.required<IOnboardingCompletionStep>();
    public isDisabled = input<boolean>(false);

    public stepClick = output<void>();

    protected stepObjectIconClass = computed(() => getIconClassByObjectType(this.step().ObjectType));

    protected onStepContainerClick(): void {
        if (this.isDisabled()) {
            return;
        }
        this.stepClick.emit();
    }
}
